/* eslint-disable react/no-danger */
import { graphql, PageProps } from 'gatsby'
import React from 'react'
import { SiteSeo } from '../components/seo/seo.component'
import { SITE_SEO_META } from '../constants/site-seo.constants'
import ConfigurePageLayout from '../layouts/page/page-layout-configure.component'

type ChangelogPageProps = PageProps<{
  markdownRemark: GatsbyTypes.MarkdownRemark
}>

const ChangelogPage: React.FC<ChangelogPageProps> = ({ data }) => (
  <ConfigurePageLayout>
    <SiteSeo title={SITE_SEO_META.CHANGELOG.title} description={SITE_SEO_META.CHANGELOG.description} />
    <div className="changelog" dangerouslySetInnerHTML={{ __html: data.markdownRemark.html || 'Visage Changelog' }} />
  </ConfigurePageLayout>
)

export default ChangelogPage

export const query = graphql`
  query {
    markdownRemark(frontmatter: { title: { eq: "Visage Changelog" } }) {
      frontmatter {
        title
      }
      html
    }
  }
`
